export class ActiveSubscriptionException {}